module.exports = {
    banners: {
        tobaccoDefault: 'https://cdn0.woolworths.media/content/banners/stopsmoking-groupbanner-lf.jpg',
        tobaccoSmall: 'https://cdn0.woolworths.media/content/banners/stopsmoking-groupbanner-sf.jpg',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/banners.js